import { useState } from "react";

const EditPost = ({ post, token, onClose, onSaved }) => {
  const [name, setName] = useState(post.image_name);
  const [gallery, setGallery] = useState(post.gallery_name);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!name) return setError("Name is required.");
    if (!gallery) return setError("Gallery is required.");

    setError("");
    setSubmitting(true);

    try {
      const res = await fetch(`/api/gallery/posts?id=${post.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.access_token}`,
        },
        body: JSON.stringify({ image_name: name, gallery_name: gallery }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to save");

      onSaved(data.data);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button style={closeButtonStyle} onClick={onClose}>✕</button>
        <h2>Edit Post</h2>

        <div style={fieldStyle}>
          <label>Name</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} style={inputStyle} />
        </div>

        <div style={fieldStyle}>
          <label>Gallery</label>
          <input type="text" value={gallery} onChange={(e) => setGallery(e.target.value)} style={inputStyle} />
        </div>

        {error && <p style={errorStyle}>{error}</p>}

        <button onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

const overlayStyle = { position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
const modalStyle = { position: "relative", background: "#fff", color: "#000", padding: "2rem", borderRadius: "8px", width: "400px", maxWidth: "90vw", display: "flex", flexDirection: "column", gap: "0.5rem" };
const closeButtonStyle = { position: "absolute", top: "0.75rem", right: "0.75rem", background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer" };
const fieldStyle = { display: "flex", flexDirection: "column", gap: "0.25rem" };
const inputStyle = { padding: "0.4rem", fontSize: "1rem" };
const errorStyle = { color: "red", fontSize: "0.85rem" };

export default EditPost;